export default __webpack_public_path__ + "static/media/accept.51f9e389.svg";